import {
  PricingPlan,
  PricingPlanEntitlement,
} from 'src/queries/organizations/pricingPlans/pricingPlans.models'

export const TOTAL_SEATS_ENTITLEMENT_KEY = 'total-seats'

function buildQuantityMaxSeatCapDisplayName(
  plan: PricingPlan,
): string | undefined {
  const quantityMax = plan.pricing.quantityMax

  if (quantityMax === undefined || quantityMax === null) {
    return undefined
  }

  return `Up to ${quantityMax} users`
}

export function buildSeatCapDisplayName(plan: PricingPlan): string | undefined {
  return (
    buildQuantityMaxSeatCapDisplayName(plan) ?? plan.numUsersRestrictionDisplay
  )
}

export function buildEntitlementDisplayName(
  plan: PricingPlan,
  entitlement: PricingPlanEntitlement,
): string {
  if (entitlement.key !== TOTAL_SEATS_ENTITLEMENT_KEY) {
    return entitlement.displayName
  }

  return buildQuantityMaxSeatCapDisplayName(plan) ?? entitlement.displayName
}
